import { Grid, Typography } from "@mui/material";
import React from "react";
import AssessmentGradingStatusCards from "../../components/Metrics/AssessmentGradingStatusCards";
import { useParams, useSearchParams } from "react-router-dom";

const AssessmentGradingListPage: React.FC = () => {

  const { jobId, applicantId } = useParams();
  const [searchParams] = useSearchParams();
  const isViewMode = searchParams.get('view') === 'true';
  console.log(jobId, applicantId, 'isViewMode:', isViewMode)
  return (
    <div className="assessmentListPage">
      <Grid container direction="column">
        <Typography variant="h4" fontWeight="bold" sx={{ fontFamily: "inherit", marginBottom: '0.5rem', marginTop: '0.5rem' }}>
          {isViewMode ? 'Assessment Results' : 'Available Assessments'}
        </Typography>
        <AssessmentGradingStatusCards jobId={jobId} applicantId={applicantId} />
      </Grid>
    </div>
  );
}

export default AssessmentGradingListPage